import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'

const NewsTickerControlButton = ({ paused, pauseNewsTicker, resumeNewsTicker, deviceType, isTouchDevice }) => {
  const [hover, setHover] = useState(false)
  const [isPlayButton, setIsPlayButton] = useState(false)

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false)
        setIsPlayButton(paused)
      }}
    >
      <Button
        classes={{ root: 'untracked' }}
        className='dn-m ttn white f5 lh-copy font-default news-ticker-toggle-button'
        style={{ width: '4.75rem' }}
        disabled={!isTouchDevice}
        onClick={(e) => {
          e.preventDefault()
          if (isTouchDevice) {
            paused ? resumeNewsTicker() : pauseNewsTicker()
          }
        }}
      >
        {isTouchDevice && paused && <PlayButton {...{ isPlayButton }} />}
        {isTouchDevice && !paused && hover && <Fade in timeout={1000}><PauseCircleOutlineIcon /></Fade>}
        {isTouchDevice && !paused && !hover && <Fade mountOnEnter in exit timeout={1000}><div>Updates</div></Fade>}
        {!isTouchDevice && <div>Updates</div>}
      </Button>
      {deviceType && deviceType.isMobile && (
        <IconButtonController {...{ paused, resumeNewsTicker, pauseNewsTicker, isPlayButton, hover, setHover }} />
      )}
    </div>
  )
}

const PlayButton = ({ isPlayButton }) => isPlayButton
  ? <PlayCircleOutlineIcon />
  : (
    <Fade in timeout={1000}>
      <PlayCircleOutlineIcon />
    </Fade>
    )

const IconButtonController = ({ paused, resumeNewsTicker, pauseNewsTicker }) => (
  <IconButton
    size='small'
    className='white ph4'
    onClick={() => paused ? resumeNewsTicker() : pauseNewsTicker()}
  >
    {paused ? <PlayCircleOutlineIcon /> : <PauseCircleOutlineIcon />}
  </IconButton>
)
export default NewsTickerControlButton
